"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Text = exports.StyledStar = exports.Related = exports.Rating = exports.Price = exports.Byline = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _polished = require("polished");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Star = _interopRequireDefault(require("../../svg/Star.svg"));
var _Button = _interopRequireDefault(require("../action/Button"));
var _Img = _interopRequireDefault(require("../figure/Img"));
var _Body = _interopRequireDefault(require("../primitive/Body"));
var _Title = _interopRequireDefault(require("../primitive/Title"));
var _theme = require("../../constants/theme");
var _VideoLabel = _interopRequireDefault(require("../primitive/VideoLabel"));
var _excluded = ["photo", "discountName", "discountIcon", "discountDescription", "videoUrl", "fullCircleImageUrl", "children", "rightIcon", "leftIcon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var UnitTile = function UnitTile(_ref, ref) {
  var photo = _ref.photo,
    discountName = _ref.discountName,
    discountIcon = _ref.discountIcon,
    discountDescription = _ref.discountDescription,
    videoUrl = _ref.videoUrl,
    fullCircleImageUrl = _ref.fullCircleImageUrl,
    children = _ref.children,
    rightIcon = _ref.rightIcon,
    leftIcon = _ref.leftIcon,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Container, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(ImageWrapper, null, discountName && /*#__PURE__*/_react["default"].createElement(DiscountButton, {
    variant: "outline",
    size: "small"
  }, /*#__PURE__*/_react["default"].createElement(DiscountIcon, null, discountIcon), discountName), discountDescription && discountName && /*#__PURE__*/_react["default"].createElement(DiscountHover, null, /*#__PURE__*/_react["default"].createElement(_Body["default"], {
    variant: "small"
  }, discountDescription), /*#__PURE__*/_react["default"].createElement(Triangle, null)), rightIcon && /*#__PURE__*/_react["default"].createElement(RightIconWrapper, null, rightIcon), /*#__PURE__*/_react["default"].createElement(LeftIconWrapper, null, leftIcon === null || leftIcon === void 0 ? void 0 : leftIcon.map(function (icon, i) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: i
    }, icon);
  })), /*#__PURE__*/_react["default"].createElement(_VideoLabel["default"], {
    videoUrl: videoUrl,
    fullCircleImageUrl: fullCircleImageUrl
  }), /*#__PURE__*/_react["default"].createElement(StyledImg, Object.assign({
    layout: "ratio",
    ratio: 3 / 4
  }, photo))), children);
};
var Rating = exports.Rating = function Rating(_ref2) {
  var rating = _ref2.rating;
  return rating ? /*#__PURE__*/_react["default"].createElement(RatingContainer, null, /*#__PURE__*/_react["default"].createElement(StyledRating, {
    variant: "small"
  }, /*#__PURE__*/_react["default"].createElement(StyledStar, null), /*#__PURE__*/_react["default"].createElement(Number, null, rating))) : null;
};
var Price = exports.Price = function Price(_ref3) {
  var totalPrice = _ref3.totalPrice,
    totalNights = _ref3.totalNights,
    totalPriceText = _ref3.totalPriceText,
    nightPrice = _ref3.nightPrice,
    nightPriceText = _ref3.nightPriceText,
    originalPrice = _ref3.originalPrice,
    discountPercentage = _ref3.discountPercentage;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, totalPrice ? /*#__PURE__*/_react["default"].createElement(TotalPriceWrapper, null, totalPrice && /*#__PURE__*/_react["default"].createElement(TotalPrice, null, totalPrice), totalPriceText && /*#__PURE__*/_react["default"].createElement(TotalPriceText, {
    as: "span"
  }, totalPriceText), originalPrice && /*#__PURE__*/_react["default"].createElement(OriginalPrice, null, originalPrice), originalPrice && /*#__PURE__*/_react["default"].createElement(DiscountTag, null, discountPercentage, "%"), totalNights && /*#__PURE__*/_react["default"].createElement(TotalNights, null, totalNights)) : nightPrice ? /*#__PURE__*/_react["default"].createElement(NightPrice, null, nightPrice && nightPrice, " ", nightPriceText && /*#__PURE__*/_react["default"].createElement("span", null, nightPriceText)) : null);
};
var Related = exports.Related = function Related(_ref4) {
  var related = _ref4.related;
  return /*#__PURE__*/_react["default"].createElement(RelatedContainer, null, related);
};
var Byline = exports.Byline = function Byline(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_react["default"].createElement(StyledByline, null, children);
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__Container",
  componentId: "sc-shq0no-0"
})(["text-decoration:none;color:inherit;display:flex;flex-direction:column;width:44.8rem;margin-right:", ";scroll-snap-align:start;&:last-of-type{margin-right:22.4rem;}> div:first-of-type{position:relative;}> div:nth-of-type(2){display:flex;align-items:center;}margin-bottom:0px !important;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing['50_Semi'];
});
var ImageWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__ImageWrapper",
  componentId: "sc-shq0no-1"
})(["margin-bottom:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing['30_Small'];
});
var StyledImg = (0, _styledComponents["default"])(_Img["default"]).withConfig({
  displayName: "UnitTile__StyledImg",
  componentId: "sc-shq0no-2"
})(["margin:0;position:relative;"]);
var DiscountIcon = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__DiscountIcon",
  componentId: "sc-shq0no-3"
})(["display:flex;flex-direction:column;align-items:center;> svg{margin-right:0.3rem;}"]);
var DiscountHover = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__DiscountHover",
  componentId: "sc-shq0no-4"
})(["max-width:27.7rem;background:", ";border-radius:0.8rem;color:", ";font-family:", ";font-size:1.4rem;padding:", ";position:absolute;top:", ";left:", ";opacity:0;transition:opacity 0.25s;z-index:1;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral['60'];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.neutral['0'];
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontFamily.body;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacing['40_Standard'];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing['70_XLarge'];
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing['30_Small'];
});
var DiscountButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "UnitTile__DiscountButton",
  componentId: "sc-shq0no-5"
})(["z-index:1;position:absolute;left:", ";top:", ";font-family:", ";color:", ";--border-color:", ";border-radius:0.8rem;text-align:center;box-shadow:0 0 0 1px var(--border-color);:hover,:focus,:active{background:", ";color:", ";+ ", "{opacity:0.9;}}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacing['30_Small'];
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.spacing['30_Small'];
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontFamily.body;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.primary['70'];
}, function (_ref18) {
  var theme = _ref18.theme;
  return (0, _polished.rgba)(theme.colors.primary['70'], 0.24);
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.neutral['0'];
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.primary['80'];
}, DiscountHover);
var RatingContainer = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__RatingContainer",
  componentId: "sc-shq0no-6"
})(["display:flex;align-items:center;"]);
var StyledRating = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  displayName: "UnitTile__StyledRating",
  componentId: "sc-shq0no-7"
})(["display:flex;align-items:baseline;color:", ";margin-right:", ";margin-bottom:", ";"], function (_ref21) {
  var theme = _ref21.theme;
  return theme.colorAssignments.rating ? (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.rating) : theme.colors.secondary['30'];
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.spacing['30_Small'];
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.spacing['30_Small'];
});
var StyledStar = exports.StyledStar = (0, _styledComponents["default"])(_Star["default"]).withConfig({
  displayName: "UnitTile__StyledStar",
  componentId: "sc-shq0no-8"
})(["margin:0;display:inline-block;margin-right:", ";"], function (_ref24) {
  var theme = _ref24.theme;
  return theme.spacing['20_Tiny'];
});
var Number = _styledComponents["default"].span.withConfig({
  displayName: "UnitTile__Number",
  componentId: "sc-shq0no-9"
})(["margin:0;font-family:", ";align-self:start;"], function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontFamily.body;
});
var Text = exports.Text = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  displayName: "UnitTile__Text",
  componentId: "sc-shq0no-10"
})(["margin-bottom:", ";margin-top:", ";"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.spacing['30_Small'];
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.spacing['20_Tiny'];
});
var TotalPriceWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__TotalPriceWrapper",
  componentId: "sc-shq0no-11"
})(["display:flex;font-size:1.6rem;font-weight:700;align-items:center;"]);
var TotalPrice = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  displayName: "UnitTile__TotalPrice",
  componentId: "sc-shq0no-12"
})(["color:", ";font-size:1.6rem;font-weight:700;margin-right:0.8rem;*{color:", ";font-size:1.6rem;font-weight:700;}"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.colors.neutral['100'];
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.neutral['100'];
});
var TotalPriceText = (0, _styledComponents["default"])(_Body["default"]).attrs({
  variant: 'small'
}).withConfig({
  displayName: "UnitTile__TotalPriceText",
  componentId: "sc-shq0no-13"
})(["display:inline;margin-right:", ";"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.spacing['20_Tiny'];
});
var NightPrice = (0, _styledComponents["default"])(TotalPrice).withConfig({
  displayName: "UnitTile__NightPrice",
  componentId: "sc-shq0no-14"
})(["font-size:1.4rem;"]);
var OriginalPrice = _styledComponents["default"].span.withConfig({
  displayName: "UnitTile__OriginalPrice",
  componentId: "sc-shq0no-15"
})(["text-decoration:line-through;margin-right:0.8rem;font-size:1.6rem;color:", ";"], function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.neutral['40'];
});
var Triangle = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__Triangle",
  componentId: "sc-shq0no-16"
})(["width:0;height:0;border-left:1rem solid transparent;border-right:1rem solid transparent;border-bottom:1rem solid ", ";position:absolute;top:-0.8rem;"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.neutral['60'];
});
var RelatedContainer = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__RelatedContainer",
  componentId: "sc-shq0no-17"
})(["display:flex;font-family:", ";margin-top:2rem;font-size:1.6rem;"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.fontFamily.body;
});
var StyledByline = (0, _styledComponents["default"])(_Title["default"]).withConfig({
  displayName: "UnitTile__StyledByline",
  componentId: "sc-shq0no-18"
})(["font-weight:300;"]);
var DiscountTag = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__DiscountTag",
  componentId: "sc-shq0no-19"
})(["display:flex;align-items:center;padding:0 0.4rem 0 0.6rem;border:1px solid rgba(62,113,169,0.25);border-radius:0.4rem;font-size:", ";color:", ";margin-right:", ";"], function (_ref34) {
  var theme = _ref34.theme;
  return (0, _theme.getFontCss)(theme.fontSizes.body.tiny);
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.primary['60'];
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.spacing['20_Tiny'];
});
var TotalNights = _styledComponents["default"].span.withConfig({
  displayName: "UnitTile__TotalNights",
  componentId: "sc-shq0no-20"
})(["font-size:1.6rem;color:", ";"], function (_ref37) {
  var theme = _ref37.theme;
  return theme.colors.neutral['40'];
});
var RightIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__RightIconWrapper",
  componentId: "sc-shq0no-21"
})(["z-index:1;position:absolute;right:1.2rem;top:1.2rem;"]);
var LeftIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "UnitTile__LeftIconWrapper",
  componentId: "sc-shq0no-22"
})(["z-index:1;position:absolute;left:1.2rem;bottom:1.2rem;display:flex;gap:0.5rem;"]);
var _default = exports["default"] = (0, _react.forwardRef)(UnitTile);
//# sourceMappingURL=UnitTile.js.map